import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import './OAuthCallback.css';

const OAuthCallback = () => {
  const [status, setStatus] = useState('Authenticating with Google...');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Extract code and state from URL parameters
        const urlParams = new URLSearchParams(location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const urlError = urlParams.get('error');

        if (urlError) {
          throw new Error(`Google authorization failed: ${urlError}`);
        }

        if (!code || !state) {
          throw new Error('Missing required authentication parameters');
        }

        setStatus('Verifying credentials...');

        // Exchange code and state with backend
        const response = await fetch(`${API_BASE_URL}/auth/google/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          },
          credentials: 'include' // Important: ensures session cookies are set/sent
        });

        const data = await response.json();

        if (!response.ok || data.status === 'error') {
          throw new Error(data.message || 'Authentication failed on server');
        }

        // Successfully authenticated
        setStatus('Authentication successful! Redirecting...');

        // Format user data for localStorage (matching existing structure)
        const userData = {
          email: data.user.email,
          name: data.user.name,
          picture: data.user.picture,
          isAuthenticated: true,
          is_admin: data.user.is_admin || false,
          isGoogleAuth: true
        };

        // Save to localStorage
        localStorage.setItem('user', JSON.stringify(userData));

        // Redirect to dashboard (using window.location to force App.js state re-initialization if needed)
        window.location.href = '/dashboard';

      } catch (err) {
        console.error('OAuth Callback Error:', err);
        setError(err.message || 'An unexpected error occurred during authentication');
        
        // Redirect back to login after showing error for a moment
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };

    handleCallback();
  }, [location.search, navigate]);

  return (
    <div className="oauth-callback-container">
      <div className="oauth-callback-card">
        {error ? (
          <>
            <div className="oauth-error-icon">❌</div>
            <h2 className="oauth-error-title">Authentication Failed</h2>
            <p className="oauth-error-message">{error}</p>
            <p className="oauth-redirect-message">Redirecting back to login...</p>
          </>
        ) : (
          <>
            <div className="oauth-loading-spinner"></div>
            <h2 className="oauth-status-title">Please Wait</h2>
            <p className="oauth-status-message">{status}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default OAuthCallback;
